export function toPerc(n) {
  return parseInt(n ?? "0") / 100;
}

export function doesOverride(obj, prop) {
  return obj[prop] !== undefined || obj[prop + "Perc"] !== undefined;
}

export function convertPtToNumber(point) {
  return parseInt(point?.replace("pt", "") ?? "12");
}

export function convertOutline(outlineStyle) {
  switch (outlineStyle) {
    case "dashed":
      return "Dash";
    case "dotted":
      return "SystemDot";
    case "solid":
      return "Solid";
  }
}

export function convertHorizontalAlign(horizontalAlign) {
  switch (horizontalAlign) {
    case "left":
      return "Left";
    case "right":
      return "Right";
    case "center":
      return "Center";
    default:
      return "Center";
  }
}

export function convertVerticalAlign(verticalAlign) {
  switch (verticalAlign) {
    case "top":
      return "Top";
    case "bottom":
      return "Bottom";
    case "middle":
      return "Middle";
    default:
      return "Middle";
  }
}
